export default class RowSelection {
    constructor(table) {
        this.Table = table;
    }
    getIDs() {
        let ids = [];
        let checked = this.Table.getElement().querySelectorAll('tbody th.check-column input[type=checkbox]:checked');
        if (checked.length === 0) {
            return ids;
        }
        for (let i = 0; i < checked.length; i++) {
            ids.push(parseInt(checked[i].value));
        }
        return ids;
    }
    /**
     * Get selected cells for specific column
     */
    getSelectedCells(name) {
        let ids = this.getIDs();
        if (ids.length === 0) {
            return null;
        }
        let cells = [];
        ids.forEach((id) => {
            let cell = this.Table.Cells.get(id, name);
            if (cell) {
                cells.push(cell);
            }
        });
        return cells;
    }
    getCount() {
        return this.getIDs().length;
    }
    isAllSelected() {
        return !!this.Table.getElement().querySelector('thead #cb input:checked');
    }
}
